import { Button, Popover, PopoverProps } from 'react-bootstrap';
import styled from 'styled-components';

export const PopoverWrapper = styled(Popover) <{ width?: string }>`
    max-width: ${p => p.width ? p.width : '600px'};
`;

const PopoverTemplate = (props: PopoverProps & { width?: string, dismiss?: boolean }) => {
    const dismiss = props.dismiss != null ? props.dismiss : true;

    return (
        <PopoverWrapper className='popover-wrapper' {...props}>
            <div style={{ marginBottom: dismiss ? 15 : 0 }}>
                {props.children}
            </div>
            {dismiss && (
                <Button style={{ width: '100%', padding: '3px 6px' }} onClick={() => document.body.click()}>dismiss</Button>
            )}
        </PopoverWrapper>
    );
}

export default PopoverTemplate;